// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "" + {"364":"ea613b22842487b6289a","443":"747a4b90edc63c72d096","659":"74cb7fe61d99347e4033","912":"4e51c59cee82b4fbf3b3","937":"47d7ee65151cdb0eddc4"}[chunkId] + "_bundle.js";
};